module.exports = __webpack_public_path__ + "img/23474dea170ddd8a45d089b4102f3b22.png";